import {
  breakpointSizes,
  getBreakpointDown,
  styleConstants,
} from '@paywithextend/components'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import FiltersFlyout from 'src/component-flyout/FiltersFlyout/FiltersFlyout'
import UtilityToolbarFilterButton from 'src/components/DataGrid/UtilityToolbar/UtilityToolbarFilterButton'
import FilterButton from 'src/components/FilterButton/FilterButton'
import OldFiltersFlyout from 'src/components/FiltersFlyout/FiltersFlyout'
import { createSetFiltersFlyoutOpen } from 'src/redux/actions/app.actions'
import { selectFeatureFlaggerFromState } from 'src/redux/selectors/data/featureFlagger.selectors'
import { css } from 'styled-components'
export interface FiltersFlyoutProps {
  title: string
  filters: React.ReactElement
  onReset: () => void
  loading?: boolean
  saveButton?: {
    visible: boolean
    text: string | React.ReactElement
    onClick?: () => void
  }
  resultsCount?: number
  onSave?: () => void
  onOpenFlyout?: () => void
  selectedFiltersCount?: number
}
interface FilterSectionProps {
  className?: string
  topLeftContent?: React.ReactElement
  additionalFilterElement?: React.ReactElement
  hideButtonChevron?: boolean
  filtersFlyoutProps?: FiltersFlyoutProps
  innerRef?: React.MutableRefObject<HTMLDivElement | null>
  isAll?: boolean
  appliedFiltersCount?: number
  removePadding?: boolean
  onSave?: () => void
  buttonVariant?: 'legacy' | 'toolbarIcon'
}

const FilterSection: React.FC<FilterSectionProps> = (
  props,
): React.ReactElement => {
  const buttonVariant = props.buttonVariant ?? 'legacy'
  const dispatch = useDispatch()

  const [isFiltersOpen, setIsFiltersOpen] = useState(false)
  const showNewFiltersFlyout = useSelector(
    selectFeatureFlaggerFromState,
  )?.show_new_filters_flyout

  const onFilterButtonClick = (): void => {
    setIsFiltersOpen(!isFiltersOpen)
    if (!showNewFiltersFlyout) {
      dispatch(createSetFiltersFlyoutOpen(!isFiltersOpen))
    }
  }

  return (
    <div
      className={props.className}
      id={'filterSection'}
      ref={props.innerRef}
      css={css`
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        background-color: ${styleConstants.colors.white};
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-bottom: ${props.removePadding
          ? 'none'
          : `1px solid ${styleConstants.colors.gray_light}`};
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          gap: 36px;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          padding: ${props.removePadding ? 0 : '36px 40px'};

          ${getBreakpointDown(breakpointSizes.SM)(css`
            flex-direction: column;
            gap: 20px;
            padding: ${props.removePadding ? 0 : '20px'};
          `)}
        `}
      >
        {props.topLeftContent && (
          <div
            css={css`
              display: flex;
              align-items: center;
              flex-grow: 2;

              border-top-left-radius: 10px;
              border-top-right-radius: 10px;
              background-color: ${styleConstants.colors.white};
              border-right: 1px solid ${styleConstants.colors.white};
              border-bottom: 1px solid ${styleConstants.colors.white};
              transition:
                background-color 150ms ease-out,
                border 150ms ease-out,
                margin 150ms ease-out,
                padding 150ms ease-out;

              ${props.filtersFlyoutProps !== undefined &&
              getBreakpointDown(breakpointSizes.SM)(css`
                padding-bottom: 20px;
                border-bottom: 1px solid ${styleConstants.colors.gray_light};
              `)}
            `}
          >
            {props.topLeftContent}
          </div>
        )}
        {props.filtersFlyoutProps !== undefined && (
          <div
            css={css`
              display: flex;
              transition: padding-left 150ms ease-out;
              align-items: center;
              gap: 20px;
            `}
          >
            {props.additionalFilterElement}
            {buttonVariant === 'legacy' && (
              <FilterButton
                filtersOpen={isFiltersOpen}
                onClick={onFilterButtonClick}
                hideChevron={props.hideButtonChevron}
                filterCount={props.appliedFiltersCount}
              />
            )}
            {buttonVariant === 'toolbarIcon' && (
              <UtilityToolbarFilterButton
                onFilterButtonClick={onFilterButtonClick}
                selectedFiltersCount={props.appliedFiltersCount || 0}
              />
            )}
          </div>
        )}
      </div>
      {props.filtersFlyoutProps !== undefined &&
        (showNewFiltersFlyout ? (
          <FiltersFlyout
            isOpen={isFiltersOpen}
            onClose={() => setIsFiltersOpen(false)}
            onSave={props.onSave}
            {...props.filtersFlyoutProps}
          />
        ) : (
          isFiltersOpen && (
            <OldFiltersFlyout
              onClose={(): void => setIsFiltersOpen(false)}
              onReset={
                props.filtersFlyoutProps.onReset || ((): void => undefined)
              }
              onSave={props.onSave}
              title={props.filtersFlyoutProps.title || ''}
              filters={props.filtersFlyoutProps.filters || <></>}
              loading={props.filtersFlyoutProps?.loading}
              resultsCount={props.filtersFlyoutProps?.resultsCount}
            />
          )
        ))}
    </div>
  )
}

export default FilterSection
